/**
 * @generated SignedSource<<f3973b34e2fe80c832fa5fcf7403b313>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSendToFriendModalLazy_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AuthShareModal_viewer">;
  readonly " $fragmentType": "PdpSharedSendToFriendModalLazy_viewer";
};
export type PdpSharedSendToFriendModalLazy_viewer$key = {
  readonly " $data"?: PdpSharedSendToFriendModalLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSendToFriendModalLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSendToFriendModalLazy_viewer",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AuthShareModal_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e4ca87daa4bf7a0f2ec0053ded2be239";

export default node;
